import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const homeBatteryDomain = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;
const websiteDomain = process.env.NEXT_PUBLIC_SITEMAP_HOST;

export default function A() {
    const { useLang, useRouter, gtm, Link } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang(locale === 'de' ? 'home' : 'poweroceancollection');

    const swiperList =
        locale === 'uk'
            ? [
                  {
                      title: t('sec1_title3'),
                      slogan: t('sec1_slogan3'),
                      img: ['banner3.webp', 'banner3.jpg'],
                      link: `https://energy.ecoflow.com/${locale}/products/PowerOcean-DC-Fit`,
                      theme: '',
                  },
                  {
                      title: t('sec1_title2'),
                      slogan: t('sec1_slogan2'),
                      img: ['banner2.webp', 'banner2.jpg'],
                      link: `${homeBatteryDomain}/${locale}/products/PowerOcean`,
                      theme: 'white',
                  },
              ]
            : [
                  {
                      title: t('sec1_title1'),
                      slogan: t('sec1_slogan1'),
                      img: ['banner1.webp', 'banner1.jpg'],
                      link: `${websiteDomain}/${locale}/powerstream`,
                      theme: '',
                  },
                  {
                      title: t('sec1_title2'),
                      slogan: t('sec1_slogan2'),
                      img: ['banner2.webp', 'banner2.jpg'],
                      link: `${homeBatteryDomain}/${locale}/products/PowerOcean`,
                      theme: 'white',
                  },
                  {
                      title: t('sec1_title3'),
                      slogan: t('sec1_slogan3'),
                      img: ['banner3.webp', 'banner3.jpg'],
                      link: `https://energy.ecoflow.com/${locale}/products/PowerOcean-DC-Fit`,
                      theme: '',
                  },
              ];

    const onSlideChange = async (swiper: any) => {
        const $currentSlider = document.querySelector('.swiper-slide-active');
        const $title = $currentSlider?.querySelector('.msg-title');
        const bannerName = $title?.innerHTML || '';

        gtm.push({
            event: 'uaEvent',
            event_name: 'view_banner',
            banner_name: bannerName,
            position: `banner_${swiper?.realIndex + 1}`,
            nonInteraction: false,
        });
    };

    const onImageClick = (params: any) => {
        const { item, position } = params;
        gtm.push(getDataLayer({ banner_name: item.title, position, type: 'Image' }));
        // router.push(item.link);
        window?.open(item?.link);
    };

    const getDataLayer = ({ position, type, banner_name }: any) => ({
        event: 'uaEvent',
        event_name: 'select_banner',
        banner_name,
        position,
        button_name: type,
    });

    const gotoPage = (link: string, banner_name: string, position: string, type: string) => {
        const finalDataLayer = getDataLayer({ banner_name, position, type });
        gtm.push(finalDataLayer);
        window?.open(link);
    };

    return (
        <div className={`ef-collection-h5-a ${css.efCollectionH5A}`}>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation={false}
                pagination={{
                    clickable: true,
                }}
                slidesPerView={'auto'}
                initialSlide={0}
                loop={swiperList.length > 1}
                onSlideChangeTransitionEnd={onSlideChange}
            >
                {swiperList.map((item: any, index: number) => (
                    <SwiperSlide
                        key={`${item.link}${index}`}
                        onClick={(event) =>
                            onImageClick({
                                item,
                                position: `banner_${index + 1}`,
                            })
                        }
                    >
                        <NextImage
                            webpSrc={require(`@publicLocal/power-ocean/collection/h5/eu/${item.img[0]}`)}
                            src={require(`@publicLocal/power-ocean/collection/h5/eu/${item.img[0]}`)}
                            alt={item.title}
                            aria-label={item.title}
                        />
                        <div className={`text-wrapper ${item.theme}`}>
                            <p className="title">{item.title}</p>
                            <p className="slogan">{item.slogan}</p>
                            {/* <Link
                                // className="msg-linkitem ef-icon-arrowright"
                                className="learn-more"
                                href={item.link}
                                ariaLabel={item.title}
                                stopPropagation
                                dataLayer={getDataLayer({
                                    banner_name: item.title,
                                    position: `banner_${index + 1}`,
                                    type: 'Learn more',
                                })}
                            >
                                {t('learn_more')}
                            </Link> */}
                            <div className="learn-more" onClick={() => gotoPage(item.link, item.title, `banner_${index + 1}`, 'Learn more')}>
                                {t('learn_more')}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
